import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/icons/search.svg'


const _hoisted_1 = { class: "w-full relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "absolute h-10 w-10 top-4 right-1 text-red-400 cursor-pointer z-50"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GMapAutocomplete, {
      placeholder: "Search for a location",
      onPlace_changed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPlace($event))),
      class: "relative",
      value: _ctx.address
    }, null, 8, ["value"]),
    (_ctx.address)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "absolute h-10 w-10 top-4 right-1 text-red-400 cursor-pointer z-50",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args)))
        }, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
  ]))
}